import { animate, keyframes, state, style, transition, trigger } from "@angular/animations";

export const visibleStateTrigger = trigger('visibleState', [
    transition(':enter', [

        animate(300, keyframes([
            style({
                transform: 'translate(-50px, -50%)',
                opacity: 0
            }),
            style({
                transform: 'translate(-20px, -50%)',
                opacity: 1
            })
        ]))
    ]),
    transition(':leave', [
        animate(300, keyframes([
            style({
                transform: 'translate(-20px, -50%)',
                opacity: 1
            }),
            style({
                transform: 'translate(-50px, -50%)',
                opacity: 0
            })
        ]))
    ])
])

export const showStateTrigger = trigger('showState', [
    state('hidden', style({
        display: 'none'
    })),
    state('fadeInLeft', style({
    })),
    transition('fadeInLeft => hidden', [
        animate('300ms ease-out', style({
            transform: 'translate(-10px, -50%)',
            opacity: 0
        }))
    ]),
    transition('hidden => fadeInLeft', [
        style({
            transform: 'translate(-10px, -50%)',
            opacity: 0,
            display: 'block'
        }),
        animate('300ms ease-out')
    ]),

    state('fadeInRight', style({
    })),
    transition('fadeInRight => hidden', [
        animate('300ms ease-out', style({
            transform: 'translate(10px, -50%)',
            opacity: 0
        }))
    ]),
    transition('hidden => fadeInRight', [
        style({
            transform: 'translate(10px, -50%)',
            opacity: 0,
            display: 'block'
        }),
        animate('300ms ease-out')
    ])
])
